import ApiService from "../../../commons/api/api_service";
import { Endpoints } from "../../../commons/api/endpoints";
import ViewModel from "../../../commons/base/view_model";
import SoScreenState from "./so_screen_state";

interface RequestBody {
    formId?: number;
}

interface ResponseBody extends SoScreenState {}

export default class SoScreenViewModel extends ViewModel<SoScreenState> {
    constructor() {
        super(new SoScreenState());
        this.updateTables();
    }

    resetAllState() {
        this.state = new SoScreenState();
        this.updateTables();
    }

    /**
     * Fetch locations, SO forms, and form items (only when a form is selected)
     * then update each states to update data in table form SO and table SO items
     */
    updateTables() {
        const formId = this.state.selectedForm;
        ApiService.fetch<RequestBody, ResponseBody>(
            Endpoints.getSoFormSubmitHistory,
            {
                parameters: { formId },
                onSuccess: (response) => {
                    this.emit((lastState) => {
                        if (response.soForms) {
                            lastState.soForms = response.soForms.map((form) => {
                                const time = new Date(
                                    Date.parse(form.formDate)
                                );
                                form.formDate = `${time.getDate()}-${
                                    time.getMonth() + 1
                                }-${time.getFullYear()}`;
                                return form;
                            });
                            lastState.soFormItems = response.soFormItems;
                            lastState.soLocations = response.soLocations;
                        }
                        return lastState;
                    });
                },
                onFailure: (error) => {
                    console.log("[error]" + error);
                },
            }
        );
    }
}
